export default __webpack_public_path__ + "static/media/img13.73cd25bd.JPG";